import { render, staticRenderFns } from "./CounselWritePage.vue?vue&type=template&id=372b775e&"
import script from "./CounselWritePage.vue?vue&type=script&lang=js&"
export * from "./CounselWritePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports